export const SHOW_TRIM_VIDEO_MODAL = 'SHOW_TRIM_VIDEO_MODAL';
export const CLOSE_TRIM_VIDEO_MODAL = 'CLOSE_TRIM_VIDEO_MODAL';
